
import { RootState } from 'store';



export const getIsAcceptCookie = (state: RootState) => state.settings.isAcceptCookie;
